export default __webpack_public_path__ + "static/media/Background_00064.67d89f1b.png";